import { GQLColourFragment, GQLProductSideAvailableDecorationType } from '@theprintbar/graphql';
import { booleanField, ensuredSearchObject, getSearchObject } from '@theprintbar/shared';
import { z } from 'zod';

export enum DesignParamKeys {
	Colour = 'colour',
	Sizes = 'sizes',
	Ref = 'ref',
	Action = 'action',
	Merch = 'merch',
	Sameday = 'sameday',
	Decoration = 'decoration',
	TeamnameId = 'teamnameId',
}

export enum DesignParamAction {
	Edit = 'edit',
	Duplicate = 'duplicate',
}

export const designParamsSchema = z.object({
	[DesignParamKeys.Colour]: z.string().optional(),
	//The Sizes
	[DesignParamKeys.Sizes]: z
		.array(
			z.object({
				size: z.string(),
				quantity: z.number().int().positive(),
			}),
		)
		.optional(),
	//The Cart Item ID
	[DesignParamKeys.Ref]: z.string().optional(),
	//Action
	[DesignParamKeys.Action]: z.nativeEnum(DesignParamAction).optional(),
	//The Merch ID
	[DesignParamKeys.Merch]: z.string().optional(),
	//Whether the order is same day
	[DesignParamKeys.Sameday]: booleanField(),
	//The decoration type
	[DesignParamKeys.Decoration]: z.nativeEnum(GQLProductSideAvailableDecorationType).optional(),
	//The team name ID
	[DesignParamKeys.TeamnameId]: z.string().optional(),
});

export type DesignParams = z.infer<typeof designParamsSchema>;

export function createDesignParams(colour?: GQLColourFragment): Partial<DesignParams> {
	return {
		colour: colour?.name,
	};
}

export function getDesignParams(request: Request): DesignParams {
	return ensuredSearchObject(request, designParamsSchema);
}
